import { Fragment, useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { saveEditWarehouse } from "actions/shopActions";
import Loading from "components/Loading";
import {
    Modal,
    ModalBody,
    ModalFooter
} from "reactstrap";
import { ReactTable } from "components/Table";


function ModalChangeWarehouse(props) {
    const [data] = useState(props?.changeWarehouse?.warehouses?.filter((v) => v?.type === "SALES_WAREHOUSE"));
    const [_id] = useState(props.changeWarehouse._id);
    // const [warehouseDefault, setWareHouseDefault] = useState(data?.find((v) => v.is_default)?.id);
    const [warehouseSelected, setWarehouseSelected] = useState(data?.filter((v) => v.is_default)?.map((v) => v.id) || []);

    var { isLoading } = props.shop;
    var { isOpenModalChangeWarehouse, openModal, saveEditWarehouse } = props;
    const { t } = useTranslation();

    const onClickSaveEditPromotion = () => {
        saveEditWarehouse({ _id, warehouseSelected }, openModal);
    };

    // const onChange = (e) => {
    //     if (e.target.name === "warehouses") {
    //         setWareHouseDefault(e.target.value);
    //     }
    // }

    const onOpenModal = () => {
        openModal();
    };
    const columns = [
        {
            dataField: "id",
            text: "",
            sort: true,
            editable: false,
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: "name",
            text: t("Name"),
            editable: false,
            sort: true,
        },
        {
            dataField: "is_default",
            text: t("Is Default"),
            editable: false,
            sort: true,
        },
        // {
        //     dataField: "effect_status",
        //     text: t("Effect Status"),
        //     editable: false,
        //     sort: true,
        // },
        {
            dataField: "address",
            text: t("Address"),
            editable: false,
            sort: true,
            formatter: (cell, row, rowIndex) => <>{cell?.contact_person}<br></br>{cell?.phone_number}, {cell?.full_address}, {cell?.city}, {cell?.postal_code}</>,
        },
    ];

    const onSelect = (row, isSelect) => {
        var warehouseSelected_tmp = warehouseSelected;
        if (isSelect) {
            warehouseSelected_tmp.push(row.id);
        } else {
            warehouseSelected_tmp = removeSelect(warehouseSelected_tmp, row.id);
        }
        var new_arr = JSON.stringify(warehouseSelected_tmp);
        setWarehouseSelected(JSON.parse(new_arr));
        if (warehouseSelected_tmp.length !== 0) {
            // setLoadingSync(false);
        }
        if (warehouseSelected_tmp.length === 0) {
            // setLoadingSync(true);
        }
    };

    const onSelectAll = (isSelect, row) => {
        var warehouseSelected_tmp = warehouseSelected;
        if (isSelect) {
            warehouseSelected_tmp = row.map((v, i) => v.id);
        } else {
            warehouseSelected_tmp = [];
        }
        setWarehouseSelected(warehouseSelected_tmp);
        if (warehouseSelected_tmp.length !== 0) {
            // setLoadingSync(false);
        }
        if (warehouseSelected_tmp.length === 0) {
            // setLoadingSync(true);
        }
    };

    const removeSelect = (arr, value) => {
        var i = 0;
        while (i < arr.length) {
            if (arr[i] === value) {
                arr.splice(i, 1);
            } else {
                ++i;
            }
        }
        return arr;
    };

    const selectRow = {
        mode: "checkbox",
        clickToSelect: false,
        selected: warehouseSelected,
        onSelect: onSelect,
        onSelectAll: onSelectAll,
        selectionHeaderRenderer: ({ indeterminate, checked, onChange }) => (
            <div className="d-flex">
                <input
                    type="checkbox"
                    ref={(input) => {
                        if (input) {
                            input.indeterminate = indeterminate;
                            input.checked = checked;
                        }
                    }}
                    onChange={onChange}
                />
                <span style={{ marginLeft: '8px' }}>({warehouseSelected.length})</span>
            </div>
        ),
    };

    return (
        <Fragment>
            <Modal centered={true} size="xl" toggle={() => { onOpenModal() }} isOpen={isOpenModalChangeWarehouse}>
                <Loading isLoading={isLoading} />
                <div className="modal-header">
                    <h1 className="mb-0 text-dark">{t("Change Warehouse")}</h1>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i className="ki-outline ki-cross fs-1" onClick={() => { onOpenModal() }} ></i>
                    </div>
                </div>
                <ModalBody>
                    <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                            <span className="required">{t("Select Default Warehouse")}</span>
                        </label>
                        <div className="row">
                            <div className="al-variants-table">
                                <ReactTable
                                    keyField="id"
                                    isSearchBar={false}
                                    columns={columns}
                                    data={data}
                                    alClassName="table-layout-inherit"
                                    isSelectRow={true}
                                    selectRow={selectRow}
                                />
                            </div>

                        </div>

                    </div>
                </ModalBody>
                <ModalFooter>
                    <button type="submit" id="kt_modal_users_search_submit" className="btn btn-primary" onClick={() => { onClickSaveEditPromotion() }}  >{t("Change")}</button>
                    <button type="reset" id="kt_modal_users_search_reset" data-bs-dismiss="modal" className="btn btn-active-light me-3" onClick={() => { onOpenModal() }} >{t("Cancel")}</button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

ModalChangeWarehouse.propTypes = {
    saveEditWarehouse: PropTypes.func.isRequired,
};
const mapStateToProps = state => ({
    shop: state.shop
});
const mapDispatchToProps = {
    saveEditWarehouse,
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalChangeWarehouse);